module.exports = __webpack_public_path__ + "img/Verint.5bac0d21.svg";